<template lang="pug">
RogueLink.action(:to="linkDestination" @click.prevent="goTo()")
  Icon.icon(:name="icon")
  .title {{ __(title, 'auto') }}
  .text {{ __(body, 'auto') }}
  .link {{ __(linkText, 'auto') }}
</template>
<script setup lang="ts">
import { useRogue } from '../../js/rogue'

const props = withDefaults(defineProps<{
  icon?: string
  title?: string
  body?: string
  linkText?: string
  linkDestination?: string
}>(), {
  icon            : 'giftcard',
  title           : '',
  body            : '',
  linkText        : '',
  linkDestination : '',
})

const rogue = useRogue()

function goTo() {
  if (rogue.router) {
    rogue.router.push(props.linkDestination)
  }
}
</script>
<style lang="scss" scoped>
$border: $border-width-thin solid $color-gray-light;

.action {
  display: inline-flex;
  flex-direction: column;
  border-right: $border;
  border-top: $border;
  align-items: center;
  padding: 40px;
  text-align: center;
  box-sizing: border-box;
  font-size: $size-xxs;
  text-decoration: none;
  background-color: inherit;

  @include not-mobile() {
    font-size: $space-s;
  }

  @include all-desktop() {
    width: 25%;
    &:last-child {
      border-right: none;
    }
  }

  @include not-desktop() {
    width: 50%;
    &:nth-child(2n) {
      border-right: none;
    }
  }
}

.icon {
  height: $size-xxxxl;
  width: $size-xxxxl;
  margin-bottom: $space-s;
}

.title {
  font-weight: $weight-bold;
  text-transform: uppercase;
  margin-bottom: $space-xxs;
  color: $color-black;
  background-color: $color-white;
}

.text {
  color: $color-black-light;
  background-color: $color-white;
  font-family: $font-condensed;
  font-weight: $weight-light;
  line-height: $line-height-m;
  margin-bottom: $space-s;
}

.link {
  color: $color-black;
  background-color: $color-white;
  text-decoration: none;

  @media(min-width: $mobile) {
    font-size: $size-xs;
  }
}
</style>
